// extracted by mini-css-extract-plugin
export default {"wrapper":"AppLayout_wrapper__zFUNU","contentWrapper":"AppLayout_contentWrapper__Drw0e"};